"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.productReviewCSVRecordSchema = void 0;
const zod_1 = require("zod");
const productReviewCSVRecordSchema = zod_1.z.object({
    rating: zod_1.z
        .string()
        .min(1, 'Rating cannot be empty')
        .transform((val) => {
        const num = Number(val);
        if (isNaN(num)) {
            throw new Error('Rating must be a valid number');
        }
        return num;
    }),
    title: zod_1.z.string(),
    text: zod_1.z.string(),
    product_id: zod_1.z.string().min(1, 'Product ID cannot be empty'),
    user_name: zod_1.z.string().min(1, 'User name cannot be empty'),
    date_reviewed: zod_1.z
        .string()
        .min(1)
        .refine((val) => !isNaN(Date.parse(val)), {
        message: 'Invalid date format',
    }),
    image_urls: zod_1.z
        .string()
        .optional()
        .transform((val) => {
        if (!val)
            return [];
        return val
            .split(',')
            .map((s) => s.trim())
            .filter((s) => s.length > 0);
    }),
});
exports.productReviewCSVRecordSchema = productReviewCSVRecordSchema;
